module.exports = __webpack_public_path__ + "img/58.d10ed6af.webp";